import React, { FunctionComponent } from 'react';
import { CompanyRegisterFormProps } from './types';
import { SimpleHeader } from '../../organisms/simpleHeader';
import { FlashBox } from '../../atoms/flashBox';
import { SimpleFooter } from '../../organisms/simpleFooter';
import { CompanyRegisterProfileForm } from '../../organisms/companyRegisterProfileForm';
import { CompanyForm, PlanPurchaseForm, UserAuthForm } from '../../../types/companyRegisterForm';
import { CompanyRegisterPlanForm } from '../../organisms/companyRegisterPlanForm';

type Props = CompanyRegisterFormProps & {
  flash: boolean;
  flashType: string;
  flashMessage: string;
  handleFlash: (flash: boolean, type: string, message: string) => void;
  section: 'profile' | 'plan';
  company: CompanyForm;
  userAuth: UserAuthForm;
  planPurchase: PlanPurchaseForm;
  handleSectionChange: (newSection: 'profile' | 'plan') => void;
  handleChange: (section: 'company' | 'userAuth' | 'planPurchase', field: string, value: string | boolean| number) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  logoPc,
  logoSp,
  recaptchaSiteKey,
  flash,
  flashType,
  flashMessage,
  handleFlash,
  section,
  company,
  userAuth,
  planPurchase,
  handleSectionChange,
  handleChange
}) => {
  const pageTitle = section === 'profile' ? 'アカウント情報を登録' : 'プラン・請求先情報を確認';

  return (
    <div className="wrap">
      <SimpleHeader
        logoPc={logoPc}
        logoSp={logoSp}
      />
      <div className="rtf-content w-100">
        <div className="rtf-company-register">
          <div className="title">
            <p className="main">{pageTitle}</p>
            <div className="status-image"></div>
          </div>
          <FlashBox
            flash={flash}
            flashType={flashType}
            flashMessage={flashMessage}
            handleFlash={handleFlash}
          />
          {section === 'profile' && (
            <CompanyRegisterProfileForm
              handleFlash={handleFlash}
              company={company}
              userAuth={userAuth}
              handleSectionChange={handleSectionChange}
              handleChange={handleChange}
            />
          )}
          {section === 'plan' && (
            <CompanyRegisterPlanForm
              handleFlash={handleFlash}
              company={company}
              userAuth={userAuth}
              planPurchase={planPurchase}
              handleChange={handleChange}
              recaptchaSiteKey={recaptchaSiteKey}
            />
          )}
        </div>
        <SimpleFooter />
      </div>
    </div>
  );
};
